<template>
  <div class="signup app-content">
    <select-occupation></select-occupation>
    <div class="pb-5">
      <div class="container ">
        <div class="row pt-4 mb-2">
          <div class="col-md-9 col-sm-12 mx-auto py-2 ">
            <h4 class="mb-30 text-center"><b>Q&A</b></h4>
            <div class="row">

              <div class="col-md-6 col-sm-12 ml-auto seach-icon pb-2">
              </div>
              <div class="col-md-6 col-sm-12 text-right pb-3">
                <b-form-select class="aeru-select w-40" v-model="searchCategory" :options="categories">
                  <template v-slot:first>
                    <b-form-select-option :value="null" disabled>{{$t("message.search_category")}}</b-form-select-option>
                  </template>
                </b-form-select>
              </div>
              <div class="col-md-12 col-sm-12 ml-auto seach-icon pb-2">
                <input class="dirty b-w-0 p-3 input_bg w-100" v-model="freeWord" :placeholder="this.$i18n.t('message.search_freeward')" >
                <font-awesome-icon fas icon="search" />
              </div>

            </div>
              <ul class="px-0">
                <li class="news-li qa-li shortcut" v-for="qa in qa_list" :key="read_more_list[qa.id]" >
                  
                  <h5 class="qa_title"><b>Q: {{qa.title.rendered}}</b></h5>
                  <span v-if="!read_more_list[qa.id]" class="answer">{{ ellipsis(qa.content.rendered).substr(0, 40) }}...<a @click="expand(qa)">{{$t("message.more_look2")}}</a></span>
                  <span v-if="read_more_list[qa.id]" class="answer" v-html="qa.content.rendered"></span>
                </li>
                <div class="hide" id='temp'>123</div>
              </ul>
              <div class="col-2 mx-auto"> 
                 <paginate
                  :page-count="getPageCount"
                  :page-range="3"
                  :margin-pages="2"
                  :click-handler="clickCallback"
                  :prev-text="'＜'"
                  :next-text="'＞'"
                  :container-class="'pagination'"
                  :page-link-class="'page-custom'"
                  :prev-link-class="'page-custom'"
                  :next-link-class="'page-custom'"
                  >
                </paginate>
              </div>
              <div class="col-md-12 col-sm-12 text-center">
                <router-link :to="'./mypage'">
                  <b-button  class="next mt-4 py-2 px-5 ml-3" > {{$t("message.to_top")}}</b-button>
                </router-link>
              </div>
              
          </div>
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'; 
import axios from 'axios';
import Paginate from 'vuejs-paginate'
export default {
  components: {
    Paginate
  },
  data () {
    return {
      qa_list: [],
      searchCategory: null,
      freeWord: "",
      categories: [],
      parPage: 5,
      currentPage: 1,
      total: 0,
      read_more_list: {},
      lang_dict: { en: "en", ja: "ja", ban: "ban", bur: "bur", ch: "ch", hin: "hi", ind: "id", kh: "ku",lao: "lao", mon: "mon", ne: "ne", taga: "tage", thai: "thai", vi: "vi"}
    }
  },
  methods: {
    isLong(value) {
      var text = this.ellipsis(value)
      return (text.length > 50)? true : false
    },
    expand(qa) {
      this.read_more_list[qa.id] = true
      this.qa_list.push({title: {rendered: ""}, content: {rendered: ""}})
      this.qa_list.pop()
    },
    ellipsis(value){
      document.querySelector("#temp").innerHTML = value;
      var textContent = document.querySelector("#temp").textContent;
      document.querySelector("#temp").innerHTML = "";

      return textContent;
    },
    clickCallback: async function (pageNum) {
       var url = ""
      if(this.lang_dict[this.language] == "ja"){
        url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?per_page=" + this.parPage + "&page=" + pageNum + "&search=" + this.freeWord + "&tags=" + this.searchCategory
      }else{
        url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?per_page=" + this.parPage + "&page=" + pageNum + "&search=" + this.freeWord + "&tags=" + this.searchCategory + "&lang=" + this.lang_dict[this.language]
      }
      await axios
      .get(url)
      .then(response => {
        this.qa_list = response.data

      }).catch(error => {
        console.log('this is error', error)
      })  
      
    }
  },
  async mounted() {
    var url = ""
    if(this.lang_dict[this.language] == "ja"){
      url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?per_page=" + this.parPage + "&page=1"
    }else{
      url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?per_page=" + this.parPage + "&page=1&lang=" + this.lang_dict[this.language]
    }
    await axios
    .get(url)
    .then(response => {
      this.qa_list = response.data
      this.total = response.headers['x-wp-total']
      console.log(response)

      for(var qa in this.qa_list) {
        this.read_more_list[this.qa_list[qa].id] = !this.isLong(this.qa_list[qa].content.rendered)
      }
      console.log(this.read_more_list)
    }).catch(error => {
      console.log('this is error', error)
    })  
    this.$store.commit('setLoading', false) 

    await axios
    .get("https://info.aelu.co.jp/wp-json/wp/v2/categories?")
    .then(response => {
      response.data.forEach((c) => {
        if(c.count > 0) {
          this.categories.push({value: c.id, text: c.name})
        }
      })

    }).catch(error => {
      console.log('this is error', error)
    })  
    this.$store.commit('setLoading', false) 
  },
  computed: {
    ...mapState({
        memberInfo: state => state.user.user,
        language: state => state.language
    }),
    getItems: function() {
      let current = this.currentPage * this.parPage;
      let start = current - this.parPage;
      return this.qa_list.slice(start, current);
     },
     getPageCount: function() {
      return Math.ceil(this.total / this.parPage);
     }
  },
  watch:{
    searchCategory(val){
      var url = ""
      if(this.lang_dict[this.language] == "ja"){
        url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?categories=" + val + "&tags=" + val + "&per_page=" + this.parPage + "&page=1"
      }else{
        url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?categories=" + val + "&tags=" + val + "&per_page=" + this.parPage + "&page=1&lang=" + this.lang_dict[this.language]
      }
      axios
      .get(url)
      .then(response => {
        this.qa_list = response.data
        this.total = response.headers['x-wp-total']
      }).catch(error => {
        console.log('this is error', error)
      }) 
    },
    freeWord(val){
      var url = ""
      if(this.lang_dict[this.language] == "ja"){
        url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?search=" + val + "&per_page=" + this.parPage + "&page=1"
      }else{
        url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?search=" + val + "&per_page=" + this.parPage + "&page=1&lang=" + this.lang_dict[this.language]
      }
      axios
      .get(url)
      .then(response => {
        this.qa_list = response.data
        this.total = response.headers['x-wp-total']
      }).catch(error => {
        console.log('this is error', error)
      }) 
    },
    language(val){
      var url = ""
      if(this.lang_dict[this.language] == "ja"){
        url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?per_page=" + this.parPage + "&page=1"
      }else{
        url = "https://info.aelu.co.jp/wp-json/wp/v2/qas?per_page=" + this.parPage + "&page=1&lang=" + this.lang_dict[val]
      }
      axios
      .get(url)
      .then(response => {
        this.qa_list = response.data
        this.total = response.headers['x-wp-total']
        this.read_more_list = {}
        for(var qa in this.qa_list) {
          this.read_more_list[this.qa_list[qa].id] = !this.isLong(this.qa_list[qa].content.rendered)
        }
        console.log(this.read_more_list)
      }).catch(error => {
        console.log('this is error', error)
      })
    }
  },

}
</script>

<style lang="scss" scoped>
::v-deep .answer{
  p {
    margin-bottom: 0px;
    white-space: normal;
  }
  font-size: 16px; 
  a {
    color: #1a0dab;
    text-decoration:underline;
    text-decoration-color:#1a0dab;
  }
}

span.answer {
  margin-bottom: 0px;
  white-space: normal;


}

.input_bg{
  background-color: #F5F5F8;
  border-radius: 26px;
}

.news-li{
  list-style: none;
}

.index_orange{
  font-weight: bold;
  color: #F29147;
}

.index_red{
  font-weight: bold;
  color: #E60028;
}

.recomend-card{
  background:linear-gradient(67.94deg, #000054 0%, rgba(0, 0, 84, 0.5) 100%);
}
.solved-probrem{
  background: linear-gradient(67.94deg, #00BDE6 0%, rgba(0, 189, 230, 0.5) 100%);
}

.look_solved{
  background: linear-gradient(67.94deg, #F29147 0%, rgba(242, 145, 71, 0.5) 100%);
}

.billing{
  background: #F29147;
  color: #FFFFFF;
  font-size: 14px;
}

.mb-30{
  margin: 30px 0px;
  margin-bottom: 60px;
}
.more{
  background: #FFFFFF;
  color: #000000;
  border: #FFFFFF;
}

.qa_title {
  margin: 10px 0px;
  margin-bottom: 10px;
  padding: 10px 0px;
  font-size: 18px;
  white-space: normal;
}
.qa-li {
  padding: 10px 0px;
  padding-bottom: 25px; 
  border-bottom: 1px solid #d8dadc
}
.seach-icon{
  position: relative;
  svg{
    position: absolute;
    top: 16px;
    right: 1.5em;
    font-size: 1.4rem;
  }
}
::v-deep .pagination{
  li{
    padding: 5px !important;
  }
}

.next{
  background: #F29147;
  color: #FFFFFF;
  border-color: #F29147;
}
.hide{
}

</style>
